"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EditMarket = _interopRequireDefault(require("./EditMarket.vue"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _systemSetting = require("@/api/systemSetting.js");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    EditMarket: _EditMarket.default,
    draggable: _vuedraggable.default
  },
  props: {
    isAlone: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // 确保所有必需的嵌套对象都存在
        var defaultData = {
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 0,
            mr: 0
          },
          showCatePopup: 0,
          cateBgColor: null
        };
        // 合并传入的数据和默认数据
        this.itemInfo = _objectSpread(_objectSpread(_objectSpread({}, defaultData), val), {}, {
          formMargin: _objectSpread(_objectSpread({
            marketLists: [{}]
          }, defaultData.formMargin), val.formMargin || {})
        });
      },
      immediate: true,
      deep: true
    }
  },
  data: function data() {
    return {
      activeSetting: 1,
      userType: null,
      // 用户类型
      TITLE_ALIGN_OPTIONS: [{
        name: '左侧对齐',
        key: 'left'
      }, {
        name: '居中对齐',
        key: 'center'
      }, {
        name: '右侧对齐',
        key: 'right'
      }],
      SHOW_ALIGN_OPTIONS: [{
        name: '田字格',
        key: 1
      }, {
        name: '列表',
        key: 2
      }],
      SORT_OPTIONS: [{
        name: '综合排序',
        key: 1
      }, {
        name: '销量升序',
        key: 2
      }, {
        name: '销量降序',
        key: 3
      }, {
        name: '价格升序',
        key: 4
      }, {
        name: '价格降序',
        key: 5
      }],
      itemInfo: {},
      showMap: {
        // sourceType
        1: '自营商品',
        2: '福司令商品',
        4: '自营+福司令',
        3: '蛋糕商品',
        18: '商户入驻商品',
        80: '来一票京东',
        81: '来一票山姆'
      },
      typeShowMap: {
        // type
        1: '指定分类',
        2: '指定标签',
        3: '指定SKU'
      },
      LYP_SORT_LABEL_MAP: {
        1: '销量降序',
        2: '价格升序（会出现价格过低商品，且个别价格低商品无法下单）',
        3: '价格降序',
        4: '评论数降序',
        5: '上架时间降序',
        6: '15天销售额降序'
      },
      priceStyle: [{
        name: '单价格',
        key: 1
      }, {
        name: '价格+购物车',
        key: 2
      }, {
        name: '价格+购物车+原价',
        key: 3
      }],
      titleListStyle: [{
        name: '样式一',
        key: 1
      }, {
        name: '样式二',
        key: 2
      }, {
        name: '样式三',
        key: 3
      }, {
        name: '样式四（带副标题）',
        key: 4
      }]
    };
  },
  mounted: function mounted() {
    // 获取用户类型
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
  },
  methods: {
    updateItem: function updateItem() {
      this.$emit("input", this.itemInfo);
    },
    marketItemRemark: function marketItemRemark() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var src = this.showMap[item.sourceType] || '';
      var bind = this.typeShowMap[item.type] || '';
      var sortTxt = [80, 81].includes(Number(item.sourceType)) && item.lypSortType != null && item.lypSortType !== '' ? this.LYP_SORT_LABEL_MAP[Number(item.lypSortType)] || '' : '';
      var parts = [src, bind].filter(Boolean);
      var s = parts.join('   ');
      if (sortTxt) {
        s = s ? "".concat(s, "\u3000").concat(sortTxt) : sortTxt;
      }
      return s || '';
    },
    addMarketContent: function addMarketContent() {
      var _this$itemInfo, _this$itemInfo2, _this$itemInfo2$marke;
      if (!((_this$itemInfo = this.itemInfo) !== null && _this$itemInfo !== void 0 && _this$itemInfo.marketLists) || !((_this$itemInfo2 = this.itemInfo) !== null && _this$itemInfo2 !== void 0 && (_this$itemInfo2$marke = _this$itemInfo2.marketLists) !== null && _this$itemInfo2$marke !== void 0 && _this$itemInfo2$marke.length)) {
        this.itemInfo['marketLists'] = [{}];
        this.$set(this.itemInfo, 'marketLists', [{}]);
        return;
      }
      ;
      this.itemInfo.marketLists.push({});
    },
    settingMarketItem: function settingMarketItem(idx) {
      var _this$$refs$EditMarke;
      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      (_this$$refs$EditMarke = this.$refs['EditMarketRef']) === null || _this$$refs$EditMarke === void 0 ? void 0 : _this$$refs$EditMarke.openInit(idx, item);
    },
    saveEdit: function saveEdit(i, item) {
      var _this$itemInfo3;
      console.log(item);
      var lists = JSON.parse(JSON.stringify(((_this$itemInfo3 = this.itemInfo) === null || _this$itemInfo3 === void 0 ? void 0 : _this$itemInfo3.marketLists) || []));
      lists[i] = item;
      this.$set(this.itemInfo, 'marketLists', lists);
      this.updateItem();
    },
    modalPicTap: function modalPicTap(tit) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.$set(_this.itemInfo, 'bgImg', img[0].sattDir);
        _this.updateItem();
      }, tit, 'system');
    },
    removeImg: function removeImg() {
      this.$set(this.itemInfo, 'bgImg', '');
      this.updateItem();
    },
    // 本地上传前的校验
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },
    // 处理本地上传
    handleLocalUpload: function () {
      var _handleLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(options, fieldName) {
        var file, formData, params, loading, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = options.file;
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: 1
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.p = 1;
              _context.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 2:
              res = _context.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.itemInfo, fieldName, res.url);
                this.updateItem();
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              loading.close();
              this.$message.error('上传失败：' + (_t.message || '请重试'));
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleLocalUpload(_x, _x2) {
        return _handleLocalUpload.apply(this, arguments);
      }
      return handleLocalUpload;
    }(),
    onEnd: function onEnd(evt) {
      var _ref = evt || {},
        oldDraggableIndex = _ref.oldDraggableIndex,
        newDraggableIndex = _ref.newDraggableIndex;
      if (oldDraggableIndex == newDraggableIndex) return;
      // 有时候位置会变为0，这时候默认改为1
      // const newIndex2 = newDraggableIndex || 1
      // const oldIndex2 = oldDraggableIndex || 1
      // let lists = JSON.parse(JSON.stringify(this.itemInfo?.marketLists||[]));
      // const currRow = JSON.parse(JSON.stringify(lists[oldIndex2 - 1]))
      // lists.splice(oldIndex2 - 1, 1) // 删除旧的
      // lists.splice(newIndex2 - 1, 0, currRow) // 存入新的
      // this.$set(this.itemInfo, 'marketLists', lists);
      this.updateItem();
    },
    removeNavItem: function removeNavItem(idx) {
      var _this$itemInfo4;
      var list = JSON.parse(JSON.stringify((_this$itemInfo4 = this.itemInfo) === null || _this$itemInfo4 === void 0 ? void 0 : _this$itemInfo4.marketLists));
      list.splice(idx, 1);
      this.$set(this.itemInfo, 'marketLists', list);
      this.updateItem();
    }
  }
};